export enum infoItemComponents {
    BIDS = 'BIDS',
    TIME_LEFT = 'TIME_LEFT',
    ITEM_PRICE = 'ITEM_PRICE',
    PRICE_LABEL = 'PRICE_LABEL',
    MANDATORY_BUYER_PROTECTION = 'MANDATORY_BUYER_PROTECTION'
}
